import { FormResource } from "../locales";

export const form: FormResource = {
    rangeOverflow: "Waarde mag niet hoger zijn dan {{max}}.",
    rangeUnderflow: "Waarde mag niet lager zijn dan {{min}}.",
    required: "Veld is vereist.",
    invalidEmail: "Ongeldig e-mailadres.",
};
